(function () {
  "use strict";

  // Collection page particles animation
  const particlesContainer = document.getElementById("collection-particles");

  if (particlesContainer) {
    // Create floating particles
    for (let i = 0; i < 30; i++) {
      const particle = document.createElement("div");
      particle.className = "particle";
      particle.style.left = Math.random() * 100 + "%";
      particle.style.animationDelay = Math.random() * 5 + "s";
      particle.style.animationDuration = Math.random() * 3 + 2 + "s";
      particlesContainer.appendChild(particle);
    }
  }

  // Collection video handling
  const video = document.querySelector(".ht-hero-video");
  if (video) {
    video.play().catch((err) => {
      console.log("Video autoplay prevented:", err);
    });
  }
})();
